import { render, staticRenderFns } from "./login-form.vue?vue&type=template&id=3b5fba7f"
import script from "./login-form.ts?vue&type=script&lang=js&external"
export * from "./login-form.ts?vue&type=script&lang=js&external"
import style0 from "./login-form.vue?vue&type=style&index=0&id=3b5fba7f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports